export default {
  GRANTED: "granted",
  DENIED: "denied",
  DEFAULT: "default",
};
